import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DataTableModule } from 'primeng/primeng';

import { CadensSharedModule } from '../../shared';
import { CadensAdminModule } from '../../admin/admin.module';

import {
    PieceJointeService,
    PieceJointePopupService,
    PieceJointeComponent,
    PieceJointeDetailComponent,
    PieceJointeDialogComponent,
    PieceJointePopupComponent,
    PieceJointeDeletePopupComponent,
    PieceJointeDeleteDialogComponent,
    pieceJointeRoute,
    pieceJointePopupRoute,
    PieceJointeResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...pieceJointeRoute,
    ...pieceJointePopupRoute,
];

@NgModule({
    imports: [
        CadensSharedModule,
        CadensAdminModule,
        DataTableModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        PieceJointeComponent,
        PieceJointeDetailComponent,
        PieceJointeDialogComponent,
        PieceJointeDeleteDialogComponent,
        PieceJointePopupComponent,
        PieceJointeDeletePopupComponent,
    ],
    entryComponents: [
        PieceJointeComponent,
        PieceJointeDialogComponent,
        PieceJointePopupComponent,
        PieceJointeDeleteDialogComponent,
        PieceJointeDeletePopupComponent,
    ],
    providers: [
        PieceJointeService,
        PieceJointePopupService,
        PieceJointeResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensPieceJointeModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/piece-jointe/piece-jointe.module.ts